import { rlog } from './remote-log';
import { initializeConnector } from '@salesforce/scv-connector-base';
import { BroadWorksConnector } from './connector';

rlog(`loaded in ${window.self === window.top ? 'a top-level window' : 'an iframe'}, referrer ${document.referrer || '(none)'}`);
initializeConnector(new BroadWorksConnector());
